
  function showTab(key, btn) {
    // hide all panels
    document.querySelectorAll('.equip-panels > div').forEach(p => p.classList.remove('active'));
    // deactivate all tabs
    document.querySelectorAll('.equip-tab').forEach(t => t.classList.remove('active'));
    // activate selected
    document.getElementById('panel-' + key).classList.add('active');
    btn.classList.add('active');
  }
